
// $(function(){
//  let b_arr = [];
//   let sel_count = 0;
//           let sel_t_count = 0;
//   let u_select_count = 0
//     let f_count_select =0;
//   $('.u_addon_master_select').change(function(){ 
//     sel_count= 0;
//       u_select_count=0;
//     console.log('deddf',$(this).find('option:selected').val())
//     $(this).find('option').removeClass('u_select')
//     if(!$(this).find('option:selected').hasClass('u_select_first')){
//     $(this).find('option:selected').addClass('u_select')
//     }  
//     //al values are zero
//       let all_price=0;
//     let all_cprice=0;
//     let f_all_price=0;
//     let f_all_cprice=0;
//   let main_p=0;
//     let main_cp=0;
//    main_p = parseInt($('.bundle-product-info .u_main_price').attr('main-price'))
//   main_cp = parseInt($('.bundle-product-info .u_cmain_price').attr('main-cprice'))
//   console.log('main price',main_p,'main cp',main_cp)
//     let ids=[];
//     console.log('change') 
//     let var_img = $(this).find('option:selected').attr('var-img')
//         let var_price = parseInt($(this).find('option:selected').attr('var-price'))
//     let var_cprice = parseInt($(this).find('option:selected').attr('var-cprice'))
//       let meta_qty = parseInt($(this).find('option:selected').attr('meta-qty'))
//     let mul_price = parseInt(var_price * meta_qty)
//     let f_price = Shopify.formatMoney(mul_price)
//       let cmul_price = parseInt(var_cprice * meta_qty)
//     let cf_price = Shopify.formatMoney(cmul_price)  
//    if(typeof var_img != 'undefined'){
//         $(this).parents('.u_addon_pro_block').find('.u_addon_pro_img_size').attr('src',var_img)
//     }    
//      $(this).parents('.u_addon_pro_block').find('.u_addon_pro_price').text(f_price)     
//     $(this).parents('.u_addon_pro_block').find('.u_addon_pro_cprice').text(cf_price)  
//     //items push to array
//      $('.u_addon_master_select').each(function(){
   
//         let id =$(this).find('option:selected').attr('value');
//        let qty =$(this).find('option:selected').attr('meta-qty');
//        if(typeof id != 'undefined'){
//         let item={"id":id,"quantity":qty};
//        console.log('item',item)
//          console.log('indexof')       
//         ids.push(item);
//        }  
//      sel_t_count =  ++sel_count
//       })    
//     console.log('total count select',sel_t_count);
//     //default variant
//     $('.u_pro_adddon_id').each(function(){
//     if(typeof $('.u_pro_adddon_id').attr('value') != 'undefined'){
//          let id =$('.u_pro_adddon_id').attr('value');
//        let qty =$('.u_pro_adddon_id').attr('meta-qty');
//        let item2={"id":id,"quantity":qty};
//         ids.push(item2);
//     }
//     })
//     console.log('array',ids);
//     b_arr = ids
//     //selected option
//     $('.u_addon_master_select option.u_select').each(function(){   
// let var_price = parseInt($(this).attr('var-price'))
//     let var_cprice = parseInt($(this).attr('var-cprice'))
//       let meta_qty = parseInt($(this).attr('meta-qty'))
//     let mul_price = parseInt(var_price * meta_qty)
//       let cmul_price = parseInt(var_cprice * meta_qty)
//     all_price += mul_price;
//       all_cprice += cmul_price; 
//  console.log('mul_price',mul_price) 
//        f_count_select =++u_select_count;
//     })

//           f_all_price_mul = all_price + main_p
//     f_all_cprice_mul = all_price + main_cp
//       f_all_price = Shopify.formatMoney(f_all_price_mul)
//     f_all_cprice = Shopify.formatMoney(f_all_cprice_mul)
//          console.log('main price',main_p,'main cp',main_cp)  
//        console.log('all price',all_price,'c all price',all_cprice)
//      console.log('f all price',f_all_price_mul,'f c all price',f_all_cprice_mul)
//     console.log('select count',f_count_select)
//     if(f_count_select >0){
//       $('.bundle-product-info .u_main_price').text(f_all_price) 
//        $('.bundle-product-info .u_cmain_price').text(f_all_cprice)
//     }
//     else{
//        $('.bundle-product-info .u_main_price').text(Shopify.formatMoney(main_p)) 
//        $('.bundle-product-info .u_cmain_price').text(Shopify.formatMoney(main_cp))
//     }
//   })
//  $('.u_addon_pro_btn').click(function(){
//     console.log('click',b_arr)
// console.log('count',parseInt(f_count_select))
//    var c_class= $(this)
//    if(parseInt(b_arr.length) >0 ){
//      if(parseInt(sel_t_count) != parseInt(f_count_select)){
//          console.log('error')
//       $('.u_addon_err_block').show()
//       $('.u_addon_pro_err').text('Please select all variants correctly')
//      }
//    else{
//     $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             dataType: "json",
//             data:{items:b_arr},
//             beforeSend: function() {
//                $(".u_addon_pro_btn").attr("aria-busy", "true");
//               c_class.find(".loader-button__loader").addClass("loader-button__loader-show");
//               console.log('before enter');
//             },
//             success:function(rst){
//               if ($('.c_picnwtxt-main input').is(':checked')) {
//                               $('.u_p-appbtn button').trigger('click')
//               }
//               else{
//                    // $('.product-form__add-button').trigger('click')
//               }
//                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
//                   $(".header__icon-wrapper[aria-controls='mini-cart']").attr("aria-expanded" , "true");
//               setTimeout(function(){
//                 jQuery.getJSON('/cart.js', function(cart) {
//                   console.log(cart.item_count);
//                   $('.header__cart-count').text(cart.item_count);
//                 });
//               }, 1000);
//               console.log("sccess");
//                 $('.u_addon_err_block').hide()
              
//             }, 
//             error:function(err){
//                $('.u_addon_err_block').hide()
//               let error = JSON.parse(err.responseText);
//               alertify.set('notifier','position', 'bottom-left');
//                   alertify.error(error.description); 
//           console.log('error',error.description);
//               console.log("Error");
//             },complete:function(cart){
//                $(".u_addon_pro_btn").attr("aria-busy", "false");
//               setTimeout(function() {
//                 c_class.find(".loader-button__loader").removeClass("loader-button__loader-show");
//               }, 1000);
//               console.log("complete");
//             }
//           });
//    }
//    }
//    else{
//       console.log('zero length')
//       $('.u_addon_err_block').show()
//       $('.u_addon_pro_err').text('Please select all variants correctly')
//    }
//   })
// })


$(function(){
    let default_price =  $('.u_addon_pro_block:first-child').find('.u_select_first').attr('var-price')
     let default_cprice =     $('.u_addon_pro_block:first-child').find('.u_select_first').attr('var-cprice')
    $('.bundle-product-info .u_main_price').text(Shopify.formatMoney(default_price)) 
       $('.bundle-product-info .u_cmain_price').text(Shopify.formatMoney(default_cprice))
 let b_arr = [];
  let sel_count = 0;
          let sel_t_count = 0;
  let u_select_count = 0
    let f_count_select =0;
  $('.u_addon_master_select').change(function(){ 
    sel_count= 0;
      u_select_count=0;
    f_count_select =0;
    sel_t_count = 0;
    console.log('deddf',$(this).find('option:selected').val())
    $(this).find('option').removeClass('u_select')
    if(!$(this).find('option:selected').hasClass('u_select_first')){
    $(this).find('option:selected').addClass('u_select')
    }  
    //al values are zero
      let all_price=0;
    let all_cprice=0;
    let f_all_price=0;
    let f_all_cprice=0;
  let main_p=0;
    let main_cp=0;
   main_p = parseInt($('.bundle-product-info .u_main_price').attr('main-price'))
  main_cp = parseInt($('.bundle-product-info .u_cmain_price').attr('main-cprice'))
  console.log('main price',main_p,'main cp',main_cp)
    let ids=[];
    console.log('change') 
    let var_img = $(this).find('option:selected').attr('var-img')
        let var_price = parseInt($(this).find('option:selected').attr('var-price'))
    let var_cprice = parseInt($(this).find('option:selected').attr('var-cprice'))
      let meta_qty = parseInt($(this).find('option:selected').attr('meta-qty'))
    let mul_price = parseInt(var_price * meta_qty)
    let f_price = Shopify.formatMoney(mul_price)
      let cmul_price = parseInt(var_cprice * meta_qty)
    let cf_price = Shopify.formatMoney(cmul_price)  
   if(typeof var_img != 'undefined'){
        $(this).parents('.u_addon_pro_block').find('.u_addon_pro_img_size').attr('src',var_img)
    }    
     $(this).parents('.u_addon_pro_block').find('.u_addon_pro_price').text(f_price)     
    $(this).parents('.u_addon_pro_block').find('.u_addon_pro_cprice').text(cf_price)  
      $(this).parents('.u_addon_pro_block').find('.u_addon_pro_price').attr("data-rprice", f_price)     
    $(this).parents('.u_addon_pro_block').find('.u_addon_pro_cprice').attr("data-cprice", cf_price) 
    $(this).parents('.u_addon_pro_block').find('.u_addon_pro_soon').attr("data-rprice", f_price)  
    //items push to array
     $('.u_addon_master_select').each(function(){
   
        let id =$(this).find('option:selected').attr('value');
       let qty =$(this).find('option:selected').attr('meta-qty');
       if(typeof id != 'undefined'){
        let item={"id":id,"quantity":qty};
       console.log('item',item)
         console.log('indexof')       
        ids.push(item);
       }  
     sel_t_count =  ++sel_count
      })    
    console.log('total count select',sel_t_count);
    //default variant
    $('.u_pro_adddon_id').each(function(){
    if(typeof $('.u_pro_adddon_id').attr('value') != 'undefined'){
         let id =$('.u_pro_adddon_id').attr('value');
       let qty =$('.u_pro_adddon_id').attr('meta-qty');
       let item2={"id":id,"quantity":qty};
        ids.push(item2);
    }
    })
    console.log('array',ids);
    b_arr = ids
    //selected option
    $('.u_addon_master_select option.u_select').each(function(){   
let var_price = parseInt($(this).attr('var-price'))
    let var_cprice = parseInt($(this).attr('var-cprice'))
      let meta_qty = parseInt($(this).attr('meta-qty'))
    let mul_price = parseInt(var_price * meta_qty)
      let cmul_price = parseInt(var_cprice * meta_qty)
    all_price += mul_price;
      all_cprice += cmul_price; 
 console.log('mul_price',mul_price) 
       f_count_select =++u_select_count;
    })
          f_all_price_mul = all_price + main_p
    f_all_cprice_mul = all_cprice + main_cp
      f_all_price = Shopify.formatMoney(f_all_price_mul)
    f_all_cprice = Shopify.formatMoney(f_all_cprice_mul)
         console.log('main price',main_p,'main cp',main_cp)  
       console.log('all price',all_price,'c all price',all_cprice)
     console.log('f all price',f_all_price_mul,'f c all price',f_all_cprice_mul)
    console.log('select count',f_count_select)
   let default_price =  $('.u_addon_pro_block:first-child').find('.u_select_first').attr('var-price')
     let default_cprice =     $('.u_addon_pro_block:first-child').find('.u_select_first').attr('var-cprice')
    if(f_count_select >0){
      $('.bundle-product-info .u_main_price').text(f_all_price) 
       $('.bundle-product-info .u_cmain_price').text(f_all_cprice)
    }
    else{
       $('.bundle-product-info .u_main_price').text(Shopify.formatMoney(default_price)) 
       $('.bundle-product-info .u_cmain_price').text(Shopify.formatMoney(default_cprice))
    }
  })
 $('.u_addon_pro_btn').click(function(){
    console.log('click',b_arr)
console.log('count',parseInt(f_count_select))
   var c_class= $(this)
   if(parseInt(b_arr.length) >0 ){
     if(parseInt(sel_t_count) != parseInt(f_count_select)){
         console.log('error')
      $('.u_addon_err_block').show()
      $('.u_addon_pro_err').text('Please select all variants correctly')
     }
   else{
    $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data:{items:b_arr},
            beforeSend: function() {
               $(".u_addon_pro_btn").attr("aria-busy", "true");
              c_class.find(".loader-button__loader").addClass("loader-button__loader-show");
              console.log('before enter');
            },
            success:function(rst){
              if ($('.c_picnwtxt-main input').is(':checked')) {
                              $('.u_p-appbtn button').trigger('click')
              }
              else{
                   // $('.product-form__add-button').trigger('click')
              }
               document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                  $(".header__icon-wrapper[aria-controls='mini-cart']").attr("aria-expanded" , "true");
              setTimeout(function(){
                jQuery.getJSON('/cart.js', function(cart) {
                  console.log(cart.item_count);
                  $('.header__cart-count').text(cart.item_count);
                });
              }, 1000);
              console.log("sccess");
                $('.u_addon_err_block').hide()
              
            }, 
            error:function(err){
               $('.u_addon_err_block').hide()
              let error = JSON.parse(err.responseText);
              alertify.set('notifier','position', 'bottom-left');
                  alertify.error(error.description); 
          console.log('error',error.description);
              console.log("Error");
            },complete:function(cart){
               $(".u_addon_pro_btn").attr("aria-busy", "false");
              setTimeout(function() {
                c_class.find(".loader-button__loader").removeClass("loader-button__loader-show");
              }, 1000);
              console.log("complete");
            }
          });
   }
   }
   else{
      console.log('zero length')
      $('.u_addon_err_block').show()
      $('.u_addon_pro_err').text('Please select all variants correctly')
   }
  })
})